import { getAttachments } from "../api/attachments";
import { SwApiStore } from "./sw-api-store";

export const attachmentsStore = SwApiStore({
  get: () =>
    getAttachments({ includeDeleted: true, includeTeamAttachments: true }),
  init: () => [],
  onMessage: ({ message, update }) => {
    if (message.kind === "newAttachment") {
      update((attachments) => {
        attachments.push(message.item);
        return attachments;
      });
    }
    if (message.kind === "deleteAttachment") {
      update((attachments) => {
        attachments.find(
          (x) => x.attachmentId === message.item.attachmentId,
        ).deleted = true;
        return attachments;
      });
    }
  },
});
